(()=>{
  const GALLERY_SELECTOR='[data-product-gallery]';

  function normalizeSource(value){
    if(!value)return'';
    try{return new URL(value,window.location.href).href;}catch(error){return value;}
  }

  function createArrow(direction,label){
    const button=document.createElement('button');
    button.type='button';
    button.className=`product-zoom__arrow product-zoom__arrow--${direction}`;
    button.setAttribute('aria-label',label);
    button.innerHTML=direction==='prev'
      ?'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14.5 5-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      :'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9.5 5 7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return button;
  }

  function initGallery(gallery){
    if(gallery.dataset.zoomGalleryInitialized==='true')return;
    const zoom=gallery.querySelector('[data-product-zoom]');
    const image=zoom?.querySelector('[data-product-zoom-image]');
    const zoomInner=zoom?.querySelector('.product-zoom__inner');
    const triggers=[...gallery.querySelectorAll('[data-product-zoom-open]')];
    if(!zoom||!image||!zoomInner||!triggers.length)return;

    gallery.dataset.zoomGalleryInitialized='true';
    let index=Math.max(0,triggers.findIndex((trigger)=>trigger.closest('[data-gallery-slide]')?.classList.contains('is-active')));
    let touchStartX=null;
    let touchStartY=null;
    let status=null;
    let prev=null;
    let next=null;

    function updateImageSizing(){
      image.classList.toggle('product-zoom__image--secondary',index>0);
    }

    function updateStatus(){
      updateImageSizing();
      if(status)status.textContent=`${index+1} / ${triggers.length}`;
    }

    function syncMainGallery(trigger){
      const mediaId=trigger.closest('[data-gallery-slide]')?.dataset.mediaId;
      if(!mediaId)return;
      const thumb=[...gallery.querySelectorAll('[data-gallery-thumb]')].find((item)=>String(item.dataset.mediaId)===String(mediaId));
      thumb?.click();
    }

    function showZoomImage(nextIndex){
      if(!triggers.length)return;
      index=(nextIndex+triggers.length)%triggers.length;
      const trigger=triggers[index];
      const source=trigger.dataset.zoomSrc||'';
      if(!source)return;
      updateImageSizing();
      image.src=source;
      image.alt=trigger.dataset.zoomAlt||'';
      syncMainGallery(trigger);
      updateStatus();
    }

    function syncIndexFromImage(){
      const currentSource=normalizeSource(image.getAttribute('src')||'');
      if(!currentSource)return;
      const matchedIndex=triggers.findIndex((trigger)=>normalizeSource(trigger.dataset.zoomSrc||'')===currentSource);
      if(matchedIndex>=0)index=matchedIndex;
      updateStatus();
    }

    if(triggers.length>1){
      prev=createArrow('prev','Previous product image');
      next=createArrow('next','Next product image');
      status=document.createElement('span');
      status.className='product-zoom__status';
      status.setAttribute('aria-live','polite');
      status.setAttribute('aria-atomic','true');
      zoom.append(prev,next,status);
      updateStatus();

      prev.addEventListener('click',(event)=>{
        event.stopPropagation();
        showZoomImage(index-1);
      });
      next.addEventListener('click',(event)=>{
        event.stopPropagation();
        showZoomImage(index+1);
      });

      zoom.addEventListener('keydown',(event)=>{
        if(!zoom.open)return;
        if(event.key==='ArrowLeft'){
          event.preventDefault();
          showZoomImage(index-1);
        }else if(event.key==='ArrowRight'){
          event.preventDefault();
          showZoomImage(index+1);
        }
      });

      zoomInner.addEventListener('touchstart',(event)=>{
        if(event.touches.length!==1)return;
        touchStartX=event.touches[0].clientX;
        touchStartY=event.touches[0].clientY;
      },{passive:true});

      zoomInner.addEventListener('touchend',(event)=>{
        if(touchStartX===null||touchStartY===null||event.changedTouches.length!==1)return;
        const dx=event.changedTouches[0].clientX-touchStartX;
        const dy=event.changedTouches[0].clientY-touchStartY;
        touchStartX=null;
        touchStartY=null;
        const threshold=Math.min(72,Math.max(42,zoomInner.clientWidth*.08));
        if(Math.abs(dx)>threshold&&Math.abs(dx)>Math.abs(dy)*1.2)showZoomImage(dx<0?index+1:index-1);
      },{passive:true});

      zoomInner.addEventListener('touchcancel',()=>{
        touchStartX=null;
        touchStartY=null;
      },{passive:true});
    }else{
      updateImageSizing();
    }

    const observer=new MutationObserver(syncIndexFromImage);
    observer.observe(image,{attributes:true,attributeFilter:['src']});

    zoom.addEventListener('close',()=>{
      touchStartX=null;
      touchStartY=null;
      image.classList.remove('product-zoom__image--secondary');
    });
  }

  function init(scope=document){scope.querySelectorAll(GALLERY_SELECTOR).forEach(initGallery);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',(event)=>init(event.target));
})();
